'use client';

// Active-state nav links. Server-rendering would skip the
// usePathname() check; punting to a client island lets us highlight
// the current page without forcing the whole header to hydrate.

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const NAV_LINKS = [
  { href: '/networks', label: 'Networks' },
  { href: '/methods',  label: 'Methods'  },
  { href: '/pricing',  label: 'Pricing'  },
  { href: '/docs',     label: 'Docs'     },
  { href: '/status',   label: 'Status'   },
];

export function NavLinks() {
  const pathname = usePathname();

  // "active" = exact match OR a path under this nav entry
  // (e.g. /docs/billing should highlight /docs).
  const isActive = (href: string) => {
    if (href === pathname) return true;
    return pathname?.startsWith(href + '/') ?? false;
  };

  return (
    <>
      {NAV_LINKS.map((l) => {
        const active = isActive(l.href);
        return (
          <Link
            key={l.href}
            href={l.href}
            className={
              active
                ? 'rounded-md px-3 py-1.5 text-sm text-accent bg-accent/10 transition'
                : 'rounded-md px-3 py-1.5 text-sm text-ink-dim hover:text-ink hover:bg-surface-2 transition'
            }
          >
            {l.label}
          </Link>
        );
      })}
    </>
  );
}
